import React, { useEffect, useState } from "react";
import QuestionsBox from "../QuestionInstructions/QuestionsBox";
import marker from "../../../src/assests/images/marker_black.svg";
import { useTaskContext } from "../store/AlltasksContext";
import Notes from "../QuestionInstructions/Notes";
import trash from "../../../src/assests/images/trash.svg";
import plus from "../../../src/assests/images/plus_red.svg";
// import {  } from "../QuestionInstructions/VisibilityProvider";
import ImageUploadTask from "../FileuploadWithPreview/ImageUploadTask";

interface AvailbiltyQuestionsProps {
  lang: {
    currLang: string;
    imgageGifVideo: string;
    uploadImage: string;
    pageLabel: string;
    uploadText: string;
    uploadSize: string;
    addMore: string;
    instruction: string;
    addInstruction: string;
    option: string;
    questionPoint: string;
    writeHintCorrectOption: string,
    addOptions: string,
    selectCorrectOptionHint: string,
  };
}

const AvailbiltyQuestions: React.FC<AvailbiltyQuestionsProps> = ({ lang }) => {
  const { showNoTask, sectionsData, setSectionsData, showImageUploadBanner } =useTaskContext();
  console.log("Current Language Data:", lang);
  const handleNameChange = (name: string) => {
    console.log(`Name changed to ${name}`);
  };

  const handleDeleteSection = (id: number) => {
    setSectionsData((prevData) =>
      prevData.filter((section) => section.id !== id)
    );
  };

  const gridData = [
    {
      id: 1,
      title: "Notes",
      placeholderPrefix: "Write a note if required",
      notes: [{ id: 1, value: "" }],
    },
  ];
  
  const handleImageClick = (id: number) => {
    console.log(`Clicked on CreatetaskImg with ID: ${id}`);
    // Perform any action you need here
  };


  return (
    <div>
       <ImageUploadTask
        id={123}
        sectionTitle={lang.imgageGifVideo}
        placeholder="Your Name"
        pageLabel={lang.pageLabel}
        bannerProps={{
          title: lang.uploadImage,
          uploadText: lang.uploadText,
          uploadSize: lang.uploadSize,
          maintitle:"1",
          imageUrls: "",
          setuploadedImage: (image) => console.log(`Uploaded image: ${image}`),
        }}
         lang={lang}
        onClick={handleImageClick}
        instructions={[{ id: 1, value: "",image:"",smallimage: "", bigimage: "" }]}
        markerImage={marker}
        onNameChange={handleNameChange}
        trashIcon={trash} iconImage={""} setIconImage={function (value: React.SetStateAction<string>): void {
          throw new Error("Function not implemented.");
        } }        />
         <QuestionsBox
          educationalData={sectionsData}
          seteducationalData={setSectionsData}
          sectionsData={sectionsData}
          setSectionsData={setSectionsData}
          onDeleteSection={handleDeleteSection}
          combinedqtnclass={"availableqtnbox"} lang={lang} 
         />
      {showNoTask && (<Notes gridData={gridData} trashIcon={trash} plusIcon={plus} />)}
      {showImageUploadBanner && (
        <ImageUploadTask
        sectionTitle={lang.imgageGifVideo}
          placeholder="Your Name"
          pageLabel={lang.pageLabel}
          bannerProps={{
            title: lang.uploadImage,
            uploadText: lang.uploadText,
            uploadSize: lang.uploadSize,
            maintitle:"2",
            imageUrls: "",
            setuploadedImage: (image) => console.log(`Uploaded image: ${image}`),
          }}
          lang={lang}
          instructions={[{ id: 1, value: "",image:"",  smallimage: "", bigimage: "" }]}
          markerImage={marker}
          onNameChange={handleNameChange}
          trashIcon={trash} iconImage={""} setIconImage={function (value: React.SetStateAction<string>): void {
            throw new Error("Function not implemented.");
          } }        />
      )}
      
     
    </div>
  );
};

export default AvailbiltyQuestions;